import {
    FontAwesomeIcon,
    FontAwesomeLayers,
    FontAwesomeLayersText,
} from '@fortawesome/vue-fontawesome';
import { AuthService } from '@skinsoft/auth';
import { Firewall } from '@skinsoft/auth-ui';

import { UserDataStore, ArchiveDataStore, SpecimenDataStore } from '@skinsoft/entity';
import { BarcodeReader, BarcodeSubscriber, Field, Form, ItemCard, LocalizedDate, LocalizedString } from '@skinsoft/ui';
import BootstrapVue from 'bootstrap-vue';
import Vue from 'vue';
import { ToastPlugin as Toasted } from '@skinsoft/ui';

import {
    AliasDataStore,
    AliasDataStore as CollaboratorDataStore,
    AuditCampaignDataStore,
    ExpressionDataStore,
    InstitutionDataStore,
    ItemDataStore,
    LocationDataStore,
    ManifestationDataStore,
    RecordDataStore,
    ThesaurusDataStore,
    ThesaurusTermDataStore,
    WorkDataStore,
    WorkspaceDataStore,
    EntityFieldDataStore,
    TranslationDataStore,
} from '@skinsoft/entity';

import { MediaTransferHelper, ImageTransferHelper } from '@skinsoft/media-transfer-helper';
import { RecordMaskDataStore } from '@skinsoft/record-mask';
import { MaskField } from '@skinsoft/record-mask/src/components/mask-field';
import { MetaRecordMaskDataStore } from '@skinsoft/record-mask/src/meta-record-mask-data-store';

import { 
    AliasSyncDownHandler,
    AuditCampaignSyncDownHandler,
    AuditRecordSyncDownHandler,
    AuthoritySyncDownHandler,
    EntityFieldSyncDownHandler,
    LocationSyncDownHandler,
    ThesaurusSyncDownHandler,
    ThesaurusTermSyncDownHandler 
} from '@skinsoft/synchro-down-handlers';

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);
Vue.component('s-form', Form);
Vue.component('s-field', Field);
Vue.component('s-firewall', Firewall);
Vue.component('s-localized-date', LocalizedDate);
Vue.component('s-localized-string', LocalizedString);
Vue.component('s-mask-field', MaskField)
Vue.component('s-barcode-reader', BarcodeReader)
Vue.component('s-barcode-subscriber', BarcodeSubscriber)
Vue.component('s-item-card', ItemCard)

Vue.use(BootstrapVue);
Vue.use(Toasted);
Vue.use(AuthService);
// router and i18n are wired via app.use() in main.ts instead: v4/v9 no longer ship a Vue-plugin
// default export.

Vue.use(TranslationDataStore);

Vue.use(AliasDataStore);
Vue.use(ThesaurusTermDataStore);
Vue.use(ThesaurusDataStore);
Vue.use(InstitutionDataStore);
Vue.use(EntityFieldDataStore)
Vue.use(UserDataStore)
Vue.use(WorkspaceDataStore)

Vue.use(ItemDataStore);
Vue.use(ManifestationDataStore)
Vue.use(ExpressionDataStore)
Vue.use(WorkDataStore);
Vue.use(LocationDataStore);
Vue.use(EntityFieldDataStore)
Vue.use(CollaboratorDataStore)

Vue.use(AuditCampaignDataStore)
Vue.use(MediaTransferHelper)
Vue.use(ImageTransferHelper)
Vue.use(RecordDataStore)
Vue.use(RecordMaskDataStore)
Vue.use(MetaRecordMaskDataStore)
Vue.use(ArchiveDataStore)
Vue.use(SpecimenDataStore)

// Synchro down handlers
Vue.use(EntityFieldSyncDownHandler)
Vue.use(AuditCampaignSyncDownHandler)
Vue.use(AuditRecordSyncDownHandler)
Vue.use(LocationSyncDownHandler)
Vue.use(ThesaurusSyncDownHandler)
Vue.use(ThesaurusTermSyncDownHandler)
Vue.use(AliasSyncDownHandler)
Vue.use(AuthoritySyncDownHandler)

if(process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'dev') {
    Vue.config.devtools = true;
    Vue.config.productionTip = false;
} else {
    Vue.config.devtools = false;
    Vue.config.productionTip = true;
}
